// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as globalImportUrl from 'url';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { GetGuestStayItemResponse } from '../models';
import { GetGuestStaysResponse } from '../models';
import { ProblemDetails } from '../models';
/**
 * GuestStaysApi - axios parameter creator
 * @export
 */
export const GuestStaysApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [date]
     * @param {string} [reservationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGet(
      propertyId: string,
      date?: string,
      reservationId?: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdGueststaysGet.'
        );
      }
      const localVarPath = `/{propertyId}/gueststays`.replace(
        `{${'propertyId'}}`,
        encodeURIComponent(String(propertyId))
      );
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (date !== undefined) {
        localVarQueryParameter['Date'] = date;
      }

      if (reservationId !== undefined) {
        localVarQueryParameter['ReservationId'] = reservationId;
      }

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} guestStayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGuestStayIdGet(
      propertyId: string,
      guestStayId: string,
      options: any = {}
    ): RequestArgs {
      // verify required parameter 'propertyId' is not null or undefined
      if (propertyId === null || propertyId === undefined) {
        throw new RequiredError(
          'propertyId',
          'Required parameter propertyId was null or undefined when calling propertyIdGueststaysGuestStayIdGet.'
        );
      }
      // verify required parameter 'guestStayId' is not null or undefined
      if (guestStayId === null || guestStayId === undefined) {
        throw new RequiredError(
          'guestStayId',
          'Required parameter guestStayId was null or undefined when calling propertyIdGueststaysGuestStayIdGet.'
        );
      }
      const localVarPath = `/{propertyId}/gueststays/{guestStayId}`
        .replace(`{${'propertyId'}}`, encodeURIComponent(String(propertyId)))
        .replace(`{${'guestStayId'}}`, encodeURIComponent(String(guestStayId)));
      const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarUrlObj.query = {
        ...localVarUrlObj.query,
        ...localVarQueryParameter,
        ...options.query,
      };
      // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
      delete localVarUrlObj.search;
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: globalImportUrl.format(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * GuestStaysApi - functional programming interface
 * @export
 */
export const GuestStaysApiFp = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [date]
     * @param {string} [reservationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGet(
      propertyId: string,
      date?: string,
      reservationId?: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuestStaysResponse> {
      const localVarAxiosArgs = GuestStaysApiAxiosParamCreator(
        configuration
      ).propertyIdGueststaysGet(propertyId, date, reservationId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} guestStayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGuestStayIdGet(
      propertyId: string,
      guestStayId: string,
      options?: any
    ): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGuestStayItemResponse> {
      const localVarAxiosArgs = GuestStaysApiAxiosParamCreator(
        configuration
      ).propertyIdGueststaysGuestStayIdGet(propertyId, guestStayId, options);
      return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {
          ...localVarAxiosArgs.options,
          url: basePath + localVarAxiosArgs.url,
        };
        return axios.request(axiosRequestArgs);
      };
    },
  };
};

/**
 * GuestStaysApi - factory interface
 * @export
 */
export const GuestStaysApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  return {
    /**
     *
     * @param {string} propertyId
     * @param {string} [date]
     * @param {string} [reservationId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGet(
      propertyId: string,
      date?: string,
      reservationId?: string,
      options?: any
    ): AxiosPromise<GetGuestStaysResponse> {
      return GuestStaysApiFp(configuration).propertyIdGueststaysGet(
        propertyId,
        date,
        reservationId,
        options
      )(axios, basePath);
    },
    /**
     *
     * @param {string} propertyId
     * @param {string} guestStayId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    propertyIdGueststaysGuestStayIdGet(
      propertyId: string,
      guestStayId: string,
      options?: any
    ): AxiosPromise<GetGuestStayItemResponse> {
      return GuestStaysApiFp(configuration).propertyIdGueststaysGuestStayIdGet(
        propertyId,
        guestStayId,
        options
      )(axios, basePath);
    },
  };
};

/**
 * GuestStaysApi - object-oriented interface
 * @export
 * @class GuestStaysApi
 * @extends {BaseAPI}
 */
export class GuestStaysApi extends BaseAPI {
  /**
   *
   * @param {string} propertyId
   * @param {string} [date]
   * @param {string} [reservationId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GuestStaysApi
   */
  public propertyIdGueststaysGet(
    propertyId: string,
    date?: string,
    reservationId?: string,
    options?: any
  ) {
    return GuestStaysApiFp(this.configuration).propertyIdGueststaysGet(
      propertyId,
      date,
      reservationId,
      options
    )(this.axios, this.basePath);
  }

  /**
   *
   * @param {string} propertyId
   * @param {string} guestStayId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof GuestStaysApi
   */
  public propertyIdGueststaysGuestStayIdGet(
    propertyId: string,
    guestStayId: string,
    options?: any
  ) {
    return GuestStaysApiFp(this.configuration).propertyIdGueststaysGuestStayIdGet(
      propertyId,
      guestStayId,
      options
    )(this.axios, this.basePath);
  }
}
